<mat-form-field
  TsFieldStyling
  [fieldBackgroundColor]="fieldStyling().color"
  [fieldBold]="fieldStyling().is_bold"
  [targetStylingClass]="commonTargetStylingClass"
  class="flex-auto gt-xs:pr-3 url-wrapper w-full"
>
  <mat-label>
    <span
      class="block text-ellipsis overflow-hidden pointer-events-auto"
      [matTooltip]="fieldDef.label"
      tooltipIfEllipsis
      >{{ fieldDef.label }}</span
    >
  </mat-label>
  <div class="w-full flex flex-row">
    <input
      #inputControl
      matInput
      [(ngModel)]="value"
      (keyup.enter)="onBlur()"
      [maxLength]="1024"
      (blur)="onBlur()"
      [disabled]="isDisabled"
      [ngClass]="{ underline: value && !fieldDef.meta?.value_hidden, 'text-gray-default': readonly }"
      [class.blurred]="fieldDef.meta?.value_hidden"
    />
    @if (!fieldDef.meta?.value_hidden) {
      <button
        mat-button
        matSuffix
        mat-icon-button
        aria-label="Expand"
        (click)="visitUrl()"
        class="remove-email-field-url"
      >
        <mat-icon>open_in_new</mat-icon>
      </button>
      <button
        mat-button
        matSuffix
        mat-icon-button
        aria-label="Expand"
        (click)="edit()"
        class="remove-email-field-url"
        [disabled]="isDisabled"
      >
        <mat-icon>edit</mat-icon>
      </button>
    }
  </div>
</mat-form-field>
